import { Backdrop, Box, Button, CircularProgress, Grid } from "@mui/material";
import {
    DownloadOutlined,
    RotateLeftOutlined,
    RotateRightOutlined,
    SwapOutlined,
    ZoomInOutlined,
    ZoomOutOutlined,
} from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { Form, Image, Input, Space, Button as Butt } from 'antd';
import FormImage from "../../FormImage";
import { RcFile, UploadFile } from "antd/es/upload";
import { Card } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import { message, Upload } from 'antd';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import styled from "@emotion/styled";



const getBase64 = (file: RcFile): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
    });

export const Tab3 = (props: { form: any, photo?: any, signature?: any }) => {
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [photo, setphoto] = useState<any>(props.form.getFieldValue('Photo'));
    const [Signature, setSignature] = useState<any>(props.form.getFieldValue('Signature'));
    const [loading, setLoading] = useState(false);




    const onChange: UploadProps['onChange'] = async ({ fileList: newFileList }) => {
        setLoading(true);
        setFileList(newFileList);
        let file = undefined;
        if (newFileList[0]?.originFileObj) {
            file = await getBase64(newFileList[0].originFileObj as RcFile);
            props.form.setFieldValue("Photo", file);
            setphoto(file);
        }
        setLoading(false);
    };

    
    const onChangeSign: UploadProps['onChange'] = async ({ fileList: newFileList }) => {
        setLoading(true);
        setFileList(newFileList);
        let file = undefined;
        if (newFileList[0]?.originFileObj) {
            file = await getBase64(newFileList[0].originFileObj as RcFile);
            props.form.setFieldValue("Signature", file);
            setSignature(file);
        }

        setLoading(false);
    };

    setTimeout(() => {
        setphoto(props.form.getFieldValue("Photo"));
        setSignature(props.form.getFieldValue("Signature"));
    }, 1000)


    return (
        <>
            <div className='tabItem' >
                <Grid container className='border-left border' sx={{ width: "85%", position: "absolute" }}>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12} md={6} className='border-left'>
                                {/* <Meta title="Photo" /> */}
                                <Form.Item name="Photo" rules={[{ required: true, message: 'la photo est Obligatoire' }]}  >
                                    {/* <Upload showUploadList={false} onChange={e => { onChange(e) }} >
                                        <Butt style={{ marginBottom: '1em' }} >
                                            Upload Image
                                        </Butt>
                                    </Upload> */}
                                </Form.Item>
                                <Card  hoverable cover={<img alt="Photo Client" src={photo} />}  >
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={6} className='border-left'>
                                <Form.Item name="Signature" rules={[{ required: true, message: 'Signature  photo est Obligatoire' }]}  >
                                    {/* <Upload showUploadList={false} onChange={e => { onChangeSign(e) }} >
                                        <Butt style={{ marginBottom: '1em' }} >
                                            Upload Signature
                                        </Butt>
                                    </Upload> */}
                                </Form.Item>
                                <Card hoverable cover={<img alt="Signature Client" src={Signature} />} >
                                </Card>
                            </Grid>
                            <Grid item>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </>
    );

}
